'use client'

import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react'

export type Experiments = {
  [key: string]: string
} | null

const ExperimentsContext = createContext<{ experiments: Experiments }>({
  experiments: {},
})

export const useExperiment = (name: string) => {
  const { experiments } = useContext(ExperimentsContext)
  return useMemo(() => {
    if (experiments === null) return null
    if (!experiments[name]) return 'a'
    return experiments[name]
  }, [experiments])
}

export function ExperimentProvider({
  children,
  headerValue,
}: PropsWithChildren<{ headerValue: string | null }>) {
  const [experiments] = useState<Experiments>(() =>
    headerValue ? (JSON.parse(headerValue) as Experiments) : null
  )

  return (
    <ExperimentsContext.Provider value={{ experiments }}>
      {children}
    </ExperimentsContext.Provider>
  )
}
